import { Types } from '@grandvisionhq/graphql';
import '../../../../../models/add-to-cart/add-to-cart.js';
import '../../../../../models/cart/cart.js';
import { SubscriptionType } from '../../../../../models/subscription/subscription-details.js';
import '../../../../../models/checkoutState/checkoutState.js';

const getSubscriptionType = (typeDetails)=>{
    if (typeDetails.billingFrequency.valueOf() === typeDetails.deliveryFrequency.valueOf()) {
        if (typeDetails.billingFrequency === Types.BillingFrequency.MONTHLY) {
            return SubscriptionType.MONTHLY;
        }
        return SubscriptionType.QUARTERLY;
    }
    if (typeDetails.billingFrequency === Types.BillingFrequency.MONTHLY) {
        return SubscriptionType.MIXED_MONTHLY;
    }
    return SubscriptionType.MIXED_QUARTERLY;
};

export { getSubscriptionType };
//# sourceMappingURL=get-subscription-type.js.map
